import { Radio } from '@sketchnote/shared-components';
import Tippy from '@tippyjs/react';

import { getScaleOptions } from '../../create-form/components';

export const LinearRangeResponse = ({
  data,
  onChange,
  className,
  rangeClasses,
  disabled = false,
}: {
  data: any;
  className?: string;
  rangeClasses?: string;
  disabled?: boolean;
  onChange?: (value: number, index: number) => void;
}) => {
  const { higherRangeLabel, lowerRangeLabel, response, lowerRange, higherRange, title } = data;

  return (
    <div
      className={`flex mobile:flex-col laptop:flex-row mx-auto w-full justify-center ${className}`}
    >
      <Tippy content={lowerRangeLabel}>
        <span
          className={`text-gray-600 mobile:mb-6 laptop:mb-0 text-xs max-w-176 overflow-auto mt-36 inline-block text-left ${rangeClasses}`}
        >
          {lowerRangeLabel}
        </span>
      </Tippy>

      <div className="flex flex-grow justify-evenly max-w-525">
        {getScaleOptions(lowerRange || 0, higherRange || 10).map((item, index) => {
          return (
            <div
              key={`${data.index}-${index}`}
              className="w-full flex flex-col items-center justify-around"
            >
              <span className="inline-block text-sm text-center -ml-2">{item.label}</span>
              <span className="inline-block">
                <Radio
                  onChange={() => {
                    onChange?.(item.label, data.index);
                  }}
                  disabled={disabled}
                  name={`${data.title}-${data.id}`}
                  value={`${item.label}-${data.id}`}
                  checked={item.label === response.value}
                  className="text-2xl"
                />
              </span>
            </div>
          );
        })}
      </div>

      <Tippy content={higherRangeLabel}>
        <span className="text-gray-600 text-xs  max-w-176 overflow-auto mobile:-mt-10 laptop:mt-28 mobile inline-block self-end">
          {higherRangeLabel}
        </span>
      </Tippy>
    </div>
  );
};
